<template>
    <div class="wrap">
        <listHeader title="数据总览" :scenario="scenario" @optionFun="headerOptionFun" :timestamp="timestamp"></listHeader>

        <div style="padding: 40px 40px 0 40px;">
            <a-row type="flex" justify="space-between">
                <a-col :span="16">
                    <div>
                        <div class="top-title">企业数据</div>
                        <a-row type="flex" justify="space-between">
                            <a-col :span="5" class="kaoqin">
                                <p class="title">企业总数</p>
                                <p class="content"><span class="blue" @click="locationTo('/enterprise/list?status=1')">{{ enterprise.all ? enterprise.all : 0 }}</span></p>
                            </a-col>
                            <a-col :span="5" class="kaoqin">
                                <p class="title">服务中企业</p>
                                <p class="content"><span class="blue" @click="locationTo('/enterprise/list?service=1')">{{ enterprise.service ? enterprise.service : 0 }}</span></p>
                            </a-col>
                            <a-col :span="5" class="kaoqin">
                                <p class="title">合同到期提醒</p>
                                <p class="content"><span class="orange" @click="locationTo('/enterprise/list?contract=2')">{{ enterprise.toexpire ? enterprise.toexpire : 0 }}</span></p>
                            </a-col>
                            <a-col :span="5" class="kaoqin">
                                <p class="title">合同已过期</p>
                                <p class="content"><span class="red" @click="locationTo('/enterprise/list?contract=1')">{{ enterprise.expired ? enterprise.expired : 0 }}</span></p>
                            </a-col>
                        </a-row>

                        <a-row>
                            <div style="padding: 20px 0 0 0;">
                                <div class="title-equipment">员工数据</div>
                                <div  class="equipment">
                                    <a-row type="flex" justify="space-between">
                                        <a-col :span="4">
                                            <p class="title">类型</p>
                                        </a-col>
                                        <a-col :span="5">
                                            <p class="title">总员工</p>
                                        </a-col>
                                        <a-col :span="5">
                                            <p class="title">在职</p>
                                        </a-col>
                                        <a-col :span="5">
                                            <p class="title">合同提醒</p>
                                        </a-col>
                                        <a-col :span="5">
                                            <p class="title">退休提醒</p>
                                        </a-col>
                                    </a-row>
                                    <a-row v-for="(item, key) in employee" :key="key" type="flex" justify="space-between" class="line">
                                        <a-col :span="4">
                                            <p class="content">{{ item.type_str }}</p>
                                        </a-col>
                                        <a-col :span="5">
                                            <p class="content"><span class="blue" @click="locationTo('/employee/list?type=' + item.type + '&status=1')">{{ item.all ? item.all : 0 }}</span></p>
                                        </a-col>
                                        <a-col :span="5">
                                            <p class="content"><span class="blue" @click="locationTo('/employee/list?type=' + item.type + '&departure=0')">{{ item.incumbent ? item.incumbent : 0 }}</span></p>
                                        </a-col>
                                        <a-col :span="5">
                                            <p class="content"><span class="orange" @click="locationTo('/employee/list?type=' + item.type + '&contract=3')">{{ item.contract ? item.contract : 0 }}</span></p>
                                        </a-col>
                                        <a-col :span="5">
                                            <p class="content"><span class="red" @click="locationTo('/employee/list?type=' + item.type + '&retirement=3')">{{ item.retirement ? item.retirement : 0 }}</span></p>
                                        </a-col>
                                    </a-row>
                                </div>
                            </div>
                        </a-row>
                    </div>


                </a-col>
                <a-col :span="7">

                    <div>
                        <div class="top-title">职位数据</div>
                        <a-row type="flex" justify="space-between" class="warn">
                            <a-col :span="8">
                                <p class="title">小时工</p>
                                <p class="content"><span class="blue" @click="locationTo('/job/list?type=1')">{{ job[1] ? job[1].cnt : 0 }}</span></p>
                            </a-col>
                            <a-col :span="8">
                                <p class="title">派遣</p>
                                <p class="content"><span class="blue" @click="locationTo('/job/list?type=2')">{{ job[2] ? job[2].cnt : 0 }}</span></p>
                            </a-col>
                            <a-col :span="8">
                                <p class="title">代理招聘</p>
                                <p class="content"><span class="blue" @click="locationTo('/job/list?type=3')">{{ job[3] ? job[3].cnt : 0 }}</span></p>
                            </a-col>
                        </a-row>

                        <div id="warndata" style="height: 185px; width: 100%; margin-top: 40px;"></div>
                    </div>


                </a-col>

            </a-row>

            <a-row>
                <div style="padding: 40px 0 0 0;">
                    <a-row type="flex" justify="space-between">
                        <a-col :span="24">
                            <div id="anajob" style="width: 100%;height:300px; "></div>
                        </a-col>
                    </a-row>
                </div>
            </a-row>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';

// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import {BarChart, PieChart, LineChart} from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    TransformComponent,
    LegendComponent,
    ToolboxComponent,
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import {LabelLayout, UniversalTransition} from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import {CanvasRenderer} from 'echarts/renderers';
// 注册必须的组件
echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    TransformComponent,
    BarChart,
    PieChart,
    LineChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer,
    LegendComponent,
    ToolboxComponent
]);

export default {
    components: {
        listHeader,
    },
    data() {
        return {
            scenario: 'centerIndex',
            enterprise: {},
            job: {},
            jobChart: {},
            employee: {},
            month: {},
            series: {},
            timestamp: '',
        }
    },
    created() {
        this.$store.state.showLayoutMenu = false;
        this.getData();
    },
    beforeRouteLeave(to, from, next){
        this.ying && this.ying.stop();

        next();
    },
    methods: {
        getData() {
            this.http('/manage/home/index', {}, (res) => {
                this.enterprise = res.enterprise;
                this.job = res.job;
                this.employee = res.employee;
                this.timestamp = res.timestamp;

                // 统计视图
                this.$nextTick(() => {
                    if (res.series) {
                        this.chart(res.month, res.series);
                    }

                    if (res.jobChart) {
                        this.chartPie(res.jobChart);
                    }
                });

                // setTimeout(this.getData, 60000);

            }, null, 2);
        },
        // 头部操作
        headerOptionFun(e) {
            switch (e.op) {
                case 'touping':
                    window.open(this.touping);
                    break;
                default:
                    break;
            }
        },
        chart(month, data) {
            let chartDom = document.getElementById('anajob');
            let myChart = echarts.init(chartDom);
            let option;

            option = {
                title: {
                    text: '员工统计',
                    textStyle: {
                        color: '#5E6F80',
                        fontSize: 14,
                    },
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    top: 0,
                },
                grid: {
                    left: 0,
                    right: 0,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: month
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: data
            };

            option && myChart.setOption(option);
        },
        chartPie(data) {
            let chartPie = document.getElementById('warndata');
            let pieChart = echarts.init(chartPie);
            let option;
            let center = data.length > 0 ? '70%' : '50%';

            option = {
                title: {
                    text: '职位构成分析',
                    textStyle: {
                        color: '#5E6F80',
                        fontSize: 14,
                    },
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    top: '40',
                },
                grid: {
                    left: 0,
                    right: 0,
                },
                series: [
                    {
                        type: 'pie',
                        label: {
                            show: false,
                        },
                        center: [center, '55%'],
                        data:  data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };

            option && pieChart.setOption(option);
        },
        locationTo(url) {
            this.$router.push(url);
        }
    }
}
</script>

<style lang="less" src="../../assets/css/center/center.less"></style>